const mockOffers = [
  {
    type: 'taxi',
    offers: [
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa31-001',
        title: 'Upgrade to a comfort class',
        price: 120
      },
      {
        id: 'b4c3e4e6-9053-42ce-b747-e281314baa31-002',
        title: 'Upgrade to a business class',
        price: 200,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-003',
        'title': 'Upgrade to a business+ class',
        'price': 300,
      },
    ]
  },
  {
    'type': 'bus',
    'offers': []
  },
  {
    'type': 'train',
    'offers': [
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-005',
        'title': 'Upgrade to a business class',
        'price': 500,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-006',
        'title': 'Add lunch',
        'price': 50,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-007',
        'title': 'Add dinner',
        'price': 50,
      },
    ]
  },
  {
    'type': 'ship',
    'offers': [
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-008',
        'title': 'Add breakfast',
        'price': 500,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-009',
        'title': 'Upgrade to a comfort class',
        'price': 1000,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-010',
        'title': 'Upgrade to a business class',
        'price': 2300,
      },
    ]
  },
  {
    'type': 'drive',
    'offers': [
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-011',
        'title': 'B-Class car',
        'price': 200,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-012',
        'title': 'C-Class car',
        'price': 1200,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-013',
        'title': 'E-Class car',
        'price': 2000,
      },
    ]
  },
  {
    'type': 'flight',
    'offers': [
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-014',
        'title': 'Upgrade to a extra-space seat',
        'price': 100,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-015',
        'title': 'Upgrade to a business class',
        'price': 1200,
      },
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-016',
        'title': 'Upgrade to a first class',
        'price': 2000,
      },
    ]
  },
  {
    'type': 'check-in',
    'offers': [
      {
        'id': 'b4c3e4e6-9053-42ce-b747-e281314baa31-017',
        'title': 'Business class desk',
        'price': 50,
      },
    ]
  },
];

export {mockOffers};
